me-video {
  display: block;
  width: 100%;
  height: auto;
}

me-video > video {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
}

me-video.video-bg,
me-video.video-bg > video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
